module.exports = __webpack_public_path__ + "static/2a-guerra-3e7be5c8d7d7770cc33939ab7fbb9bd7.png";